
import Vue from 'vue';
import ReturnDisplay from '@/components/generic/ReturnDisplay.vue';
import IdAlerts from '@/components/IdAlerts.vue';
import { DetailedDecision, GeneralAuthentication, CaseType } from '@/plugins/digitalVerification';
import { Trustev } from '@/plugins/trustev';
import { EventBus } from '@/plugins/eventBus';
import { SnackMessage } from '@/plugins/utils';
import { RandomIP } from '@/plugins/utilities';
import { i18n, trans } from '@/i18n';
import { LogIt } from '@/plugins/webApi';

export default Vue.extend({
  data: () => ({
    caseType: 0,
    trustevResult: {},
    choice: {},
    kbaDialog: false,
    trustAuth: Array<GeneralAuthentication>(),
    alert: null,
  }),
  components: {
    ReturnDisplay,
    IdAlerts,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    show(n: boolean, o: boolean): void {
      if (n) {
          this.sendCase();
      }
    },
  },
  methods: {
    getVal(el: Element | null, def: string): string {
        if (el) {
            let out = (el as any)._value;
            if (out) {
                if (out.length > 1) {
                    return out;
                } else {
                    out = el.getAttribute('value');
                    return out;
                }
            }
        }
        return def;
    },
    sendCase(): void {
        EventBus.$emit('message', { text: trans('idvision.origination.standard.send') });
        const trustev = new Trustev({
            name: 'add_case',
            caseType: this.caseType,
            data: {
                case: RandomIP().replace(/\./gi, ''),
            },
        });
        const fName = this.getVal(document.querySelector('#FirstName'), 'David');
        const lName = this.getVal(document.querySelector('#LastName'), 'Shaw');
        const ssn = this.getVal(document.querySelector('#SSN'), '666010029');
        const email = this.getVal(document.querySelector('#email'), 'davidshaw@transunion.com');
        const phone = this.getVal(document.querySelector('#mobilePhoneNumber'), '8153444312');
        if (fName) {
            trustev.data = Object.assign(trustev.data, { firstName: fName });
        }
        if (lName) {
            trustev.data = Object.assign(trustev.data, { lastName: lName });
        }
        if (ssn) {
            trustev.data = Object.assign(trustev.data, { ssn });
        }
        if (email) {
            trustev.data = Object.assign(trustev.data, { email });
        }
        if (phone) {
            trustev.data = Object.assign(trustev.data, { phoneNumber: phone });
        }
        const addr = {
            street: '',
            city: '',
            region: '',
            postal: '',
            country: 'US',
        };
        trustev.data = Object.assign(trustev.data, { address: addr });
        trustev.Send()
        .then((resp) => {
            this.sendDetailDecision(resp.data.Id);
            LogIt(`(Components/DeviceVerify.vue)->sendCase() Sending Case for detialed decision [IDV] [CASE] ${resp.data.Id}`, false);
        })
        .catch((err) => {
            EventBus.$emit('message', { text: `${trans('error')} ${err}`, context: 'error' });
            LogIt(`(Components/DeviceVerify.vue)->sendCase() ${err}`, true);
        });
    },
    formating(dec: DetailedDecision): void {
        this.trustevResult = dec.format('rgba(128,128,128,0.2)');
        this.trustAuth = dec.formatAuthentication('rgba(128,128,128,0.2)');
    },
    sendDetailDecision(id: string): void {
        const trustev = new Trustev({
            name: 'detail',
            id,
            data: {},
        });
        trustev.Send()
        .then((resp) => {
            EventBus.$emit('message', { text: trans('idvision.origination.standard.finish') });
            const dec = new DetailedDecision(resp.data as DetailedDecision);
            const idV = new Trustev({
                name: 'id_verify',
                id: dec.IdentityVerificationPayloadUrl,
                data: {},
            });
            LogIt(`(Components/DeviceVerify.vue)->sendDetailDecision() Sent Detail Decision [IDV] [DETAILCASE] ${dec.CaseId}`, false);
            idV.Send()
            .then((respp) => {
                this.alert = respp.data;
                this.formating(dec);
            })
            .catch((err) => {
                this.formating(dec);
                LogIt(`(Components/DeviceVerify.vue)->sendDetailedDecision()->idV.Send() ${err}`, true);
            });
            EventBus.$emit('raw', { text: JSON.stringify(resp.data) });
        })
        .catch((err) => {
            EventBus.$emit('message', { text: `${trans('error')} ${err}`, context: 'error' });
            LogIt(`(Components/DeviceVerify.vue)->sendDetailedDecision() ${err}`, true);
        });
    },
    saveAddr(obj: object): void {
        this.choice = obj;
    },
  },
  mounted() {
      EventBus.$on('trustev', (obj: object) => {
          this.saveAddr(obj);
      });
      EventBus.$on('trustev_case', (str: string) => {
          this.caseType = CaseType.indexOf(str);
      });
  },
});
